module.exports = __webpack_public_path__ + "media/icons/arrow-right-square-93c55a0c.png";